import type { DocumentFlagProjection, Flag } from '~/shared/api/data-ingestion-api/client'

export function getPendingFlags<T extends Flag | DocumentFlagProjection>(flags: T[]): T[] {
  return flags.filter((flag) => {
    const status = (flag as Partial<Flag>).flag_status
    return status === undefined || status === 'pending'
  })
}
